<template>
  <div id="IndexPage">
      <!-- <Banner/> -->
      <!-- 自定义文案区域 -->
      <div class="boxBackground" >
        <div class="boxContent" v-html="tenantConfig.homeHtml"></div>
      </div>
      <!-- 师资力量 -->
      <div v-if="teacherBannerList.length>0" class="boxBackground boxBackground8">
        <div class="boxContent">
          <p class="boxTitle">师资力量</p>
          <a-carousel :autoplay="true" arrows style="width: 80%">
            <template #prevArrow>
              <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                <i class="iconfont">&#xe622;</i>
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow" style="right: 10px">
                <i class="iconfont">&#xe624;</i>
              </div>
            </template>
            <div class="TeacherBox" v-for="item,index in teacherBannerList" :key="index">
              <img :src="item.img" class="box_image" alt="" />
              <p class="teacherName">{{ item.name }}</p>
            </div>
          </a-carousel>
        </div>
      </div>
      <!-- 荣誉资质 -->
      <div v-if="certImgs.length > 0" class="index-container skyblue">
        <div class="second-title">荣誉资质</div>
        <div class="second-body certs">
          <img v-for="u in certImgs" :src="u" :key="u" alt="" />
        </div>
      </div>
      <!-- 合作单位 -->
      <div v-if="comImgs.length > 0" class="index-container skyblue">
        <div class="second-title">合作单位</div>
        <div class="second-body logos">
          <img v-for="u in comImgs" :src="u" :key="u" alt="" />
        </div>
      </div>
  </div>
</template>
<script>
// import { getAction } from "@/api/manage";
import Banner from '@/components/header/Banner'
export default {
  components: { 
    Banner
  },
  data() {
    return {
      teacherBannerList:[],
      comImgs: [],
      certImgs: []
    };
  },
  watch: {},
  methods: {},
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    if(this.tenantConfig){
      if (this.tenantConfig.banner2) {
        this.teacherBannerList = this.tenantConfig.banner2.split(",");
        let bannerList2 = this.tenantConfig.banner2.split(",");
        let bannerNameList = [];
        if(this.tenantConfig.bannerLinks2){
          bannerNameList = this.tenantConfig.bannerLinks2.split("\n");
        }
        for (let i = 0; i < bannerList2.length; i++) {
          this.teacherBannerList[i] = {
            img: bannerList2[i],
            name: bannerNameList.length <= (i-1) ? bannerNameList[i] : '',
          };
        }
      }
      if (this.tenantConfig.cert) {
        this.certImgs = this.tenantConfig.cert.split(",");
      }
      if (this.tenantConfig.com) {
        this.comImgs = this.tenantConfig.com.split(",");
      }
    }
  },
  mounted() {
  },
};
</script>
<style lang='less' scoped>
.slick-arrow {
  border-radius: 50%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 40px;
  background: #364e799a;
  overflow: hidden;
  color: #fff;
  opacity: 0.5;
  img {
    width: 100%;
    height: 100%;
  }
}
.slick-arrow:hover {
  background: #364e79;
  color: #fff;
  opacity: 1;
}

#IndexPage {
  width: 100%;
  height: auto;

  .boxBackground {
    width: 100%;
   // background: #030149;
    .boxContent {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      // max-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .boxTitle {
        width: 100%;
        line-height: 60px;
        color: #fff;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        padding-bottom: 30px;
      }
      .box_image {
        margin: auto;
        width: auto;
        height: auto;
        max-height: 500px;
      }
      .TeacherBox {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .teacherName {
          width: 100%;
          line-height: 50px;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          text-align: left;
          padding: 0 20px;
          position: absolute;
          left: 0;
          bottom: 0;
          background: rgb(10 0 85);
        }
      }
      .questionList {
        width: 100%;
        text-align: left;
        line-height: 40px;
        font-weight: bold;
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
.mobile{
  .boxBackground {
    .boxContent {
      width: 100%!important;
      /deep/img{
        max-width: 100%;
      }
    }
  }
}

.index-container {
      padding-bottom: 80px;
    }
    .gray {
      background: rgb(245, 249, 255);
    }
    .skyblue {
      background: rgb(246, 250, 254);
    }
    .second-title {
      text-align: center;
      font-size: 40px;
      color: #2c3040;
      line-height: 56px;
      margin: 0 auto 20px;
      padding-top: 80px;
    }
    .second-desc {
      text-align: center;
      font-size: 16px;
      color: #8b8c9c;
      line-height: 22px;
      margin: 20px;
    }
    .second-body {
      max-width: 1200px;
      margin: auto;
      img {
        max-width: 100%;
      }
    }
.logos {
  img {
    margin: 5px 8px;
    max-height: 100px;
    // background: #1890ff;
  }
}
.certs{
  img {
    margin: 5px 8px;
    max-height: 250px;
    // background: #1890ff;
  }
}
</style>